export const DOWNLOADING_PDF_TOAST = 'Downloading PDF...';
export const PDF_DOWNLOADED_TOAST = 'PDF downloaded successfully!';
export const PDF_DOWNLOAD_FAILED_TOAST = 'Failed to download PDF';
export const EXPORT_PDF_FILE_SUFFIX = '-executive-summary';
